export default "__VITE_ASSET__0364533a__"